// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"c387da4d","990":"28a6f9b5"}[chunkId] + ".chunk.css";
};